import React from "react";

const PRINCIPLES = [
  {
    n: "I",
    title: "Preventive Presence",
    body: "A structural philosophy. Quiet architecture that lowers physiological arousal and strengthens protective factors — without diagnosis or claim.",
  },
  {
    n: "II",
    title: "Welfare Supremacy",
    body: "Welfare defines legitimacy. Sentience before service. The working dog is a living partner entrusted to our protection.",
  },
  {
    n: "III",
    title: "Sovereignty",
    body: "Financial independence as structural protection. Sovereignty is measured not by revenue size but by freedom of refusal.",
  },
  {
    n: "IV",
    title: "Humility in Field Authority",
    body: "Command without ego. Handlers carry absolute halt-authority — exercised in service of the dog, the people present, and the doctrine.",
  },
  {
    n: "V",
    title: "Generational Ethics",
    body: "The 50-year question governs every strategic decision. We build to endure, not to expand.",
  },
  {
    n: "VI",
    title: "The Discipline of Enough",
    body: "Restraint before reaction. Protection before ambition. Humility before authority.",
  },
];

export default function GuidingPrinciples() {
  return (
    <section
      data-testid="guiding-principles"
      className="bg-white border-y border-slate-200"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8 mb-14">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="brand-rule" />
              <span className="overline">Guiding Principles</span>
            </div>
            <h2 className="mt-6 font-display font-black text-3xl md:text-5xl tracking-tight leading-[1.05] text-slate-900">
              Six commitments that govern every decision.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 md:pt-12">
            <p className="text-slate-600 leading-relaxed">
              Drawn directly from our Institutional Bible — these are the durable
              instructions we return to when the work gets loud. Leadership is temporary.
              Doctrine is permanent.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {PRINCIPLES.map((p) => (
            <div
              key={p.n}
              data-testid={`principle-${p.n}`}
              className="border-t-2 border-slate-200 hover:border-amber-600 pt-6 transition-colors"
            >
              <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-amber-600">
                Principle {p.n}
              </div>
              <h3 className="mt-3 font-display font-bold text-xl md:text-2xl text-slate-900">
                {p.title}
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed text-[15px]">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
